import "./style.scss";

/*
 * CATEGORY FILTER + Pagination
 */

window.filterWithPage = function filterWithPage(e = null) {
  const pages = document.querySelectorAll(".blog_page_numbers .page-numbers");
  pages.forEach((el) => {
    el.classList.remove("current");
  });
  e.classList.add("current");
  filterPosts("", 1);

  setTimeout(() => {
    //let target = document.getElementsByClassName("green-topbar");
    let target = document.getElementById("filter-result");
    let headerOffset = 150;
    let elementPosition = target.offsetTop;
    let offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }, 100);
};

window.filterPosts = function filterPosts(e = null, pageNumber = null) {
  //console.log(a);
  //Setting actie so it shows its clicked
  if (e) {
    e.classList.toggle("active");
    //1. Get Category id
    var id = e.getAttribute("data-id");
  } else {
    //If not e, then its clear filter
    if (!pageNumber) {
      const links = document.querySelectorAll(".categories-filter .category.active");
      links.forEach((el) => {
        el.classList.remove("active");
      });
    }
  }

  var ids = [];

  const categories = document.querySelectorAll(".categories-filter .category.active");

  categories.forEach((el) => {
    //console.log(el.getAttribute('data-id'));
    ids.push(el.getAttribute("data-id"));
  });

  var currentPageElement = document.getElementsByClassName("page-numbers current");
  if (currentPageElement.length > 0) {
    var currentPageId = currentPageElement[0].getAttribute("data-page-id");
  } else {
    var currentPageId = 1;
  }
  let reset = document.getElementById("reset-filter");
  if (reset) {
    if (ids.length === 0) {
      document.getElementById("reset-filter").classList.add("hidden");
    } else {
      document.getElementById("reset-filter").classList.remove("hidden");
    }
  }

  let filterResult = document.querySelectorAll("#filter-result")[0];

  let paginationSection = document.querySelectorAll(".blog_page_numbers")[0];

  var formData = new FormData();

  //Which php function to trigger
  formData.append("action", "category_filter");
  formData.append("term_ids", ids);

  formData.append("pageNo", currentPageId);
  let postType = document.getElementById("filter-result");
  if (postType.getAttribute("data-post-type")) {
    formData.append("post_type", "cases");
  }

  var xhttp = new XMLHttpRequest();
  xhttp.open("POST", window.location.protocol + "//" + window.location.hostname + "/wp-admin/admin-ajax.php");

  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      var response = this.responseText;

      var data = JSON.parse(response);

      if (data.status === true) {
        //console.log(data.searched_after);
        //console.log(data.result);

        //First we reset
        filterResult.innerHTML = "";

        //Then we add our result
        filterResult.innerHTML = filterResult.innerHTML + data.result;

        paginationSection.innerHTML = ""; //Then we add our result

        paginationSection.innerHTML = paginationSection.innerHTML + data.pageination;
      } else {
      }
      xhttp.abort();
    }
  };
  xhttp.send(formData);
};

window.resetFilter = function resetFilter() {
  const categories = document.querySelectorAll(".categories-filter .category.active");
  categories.forEach((el) => {
    el.classList.remove("active");
  });

  document.getElementById("reset-filter").classList.add("hidden");
  filterPosts();
};
